export default function PrivacyPolicy() {
  return (
    <section id="privacy-policy" className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Privacy Policy</h2>

        <p className="mb-6">
          <strong>Last updated:</strong> 2025-08-12
        </p>

        <p className="mb-6">
          Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect data in the <em>StockEasy Tech</em> application.
        </p>

        <h3 className="text-xl font-semibold mb-4">1. Data Collected</h3>
        <p className="mb-4">
          Our app assists with the verification of goods by scanning barcodes and labels.
        </p>
        <p className="mb-2 font-semibold">
          We do not collect, store, or share any personal information from users except for:
        </p>
        <ul className="list-disc list-inside mb-6">
          <li>Your email and password used to access the app, only if you choose to save these credentials by selecting the "Remember Me" option.</li>
          <li>These details are stored locally on your device and are not transmitted to any external servers.</li>
        </ul>

        <h3 className="text-xl font-semibold mb-4">2. Use of Data</h3>
        <p className="mb-6">
          The data is used solely to facilitate your access to the app. It is not shared with third parties nor used for other purposes.
        </p>

        <h3 className="text-xl font-semibold mb-4">3. Security</h3>
        <p className="mb-6">
          We take measures to protect information stored locally on your device. However, it is important that you keep your device secure to prevent unauthorised access.
        </p>

        <h3 className="text-xl font-semibold mb-4">4. Goods Verification Data</h3>
        <p className="mb-6">
          We do not retain any data locally within the app. Instead, all information is securely stored on our servers to enable clients to access their work history and generate support reports.
        </p>

        <h3 className="text-xl font-semibold mb-4">5. Changes to this Policy</h3>
        <p>
          We may update this Privacy Policy occasionally. We recommend reviewing this page periodically.
        </p>
      </div>
    </section>
  );
}
